<article class="client-detail-wrapper">
  <nav class="client-detail-nav">
    <div class="return-wrapper">
      <a routerLink="/dashboard/clients" class="return"><i id="icon-chevron" class="fas fa-chevron-left"></i> {{'BACK' | translate}}</a>
    </div>
    <ul class="nav-list">
      <li class="nav-item">
        <a class="nav-button" routerLink="overview" routerLinkActive="active">
          {{'PROGRESS' | translate}}
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-button" routerLink="edit" routerLinkActive="active"> {{'PROFILE' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-button" routerLink="chat" routerLinkActive="active"> {{'CHAT' | translate}}</a>
      </li>
    </ul>
  </nav>

  <div class="router-outlet-container">
    <router-outlet></router-outlet>
  </div>
</article>
